export enum CampaignBuilderEnum {
	LITE = 'lite',
	LEGACY = 'legacy',
}

export enum DuplicateCampaignConfirmationModalText {
	TITLE = 'Do you want to duplicate this campaign?',
	DESCRIPTION_NO_SEND = 'You will create a new draft campaign based on this campaign.',
	DESCRIPTION = 'You will create a new draft campaign based on this campaign. Parts of your campaign such as audience and delivery channel configuration will not be copied over.',
	DESCRIPTION_INBOX = 'You will create a new draft campaign based on this campaign. Parts of your campaign such as audience will not be copied over.',
}

export enum videoViewerEnum {
	VIDEO_PAGE = 'videoPage',
	WIDGET = 'widget',
}

export enum widgetPlacementFields {
	WIDGET_DOMAIN = 'widgetDomain',
	WIDGET_PATH = 'widgetPath',
	WIDGET_HIDE_ON_MOBILE = 'widgetHideOnMobile',
}

export enum campaignTemplateTypeEnum {
	sms = 'sms',
	email = 'email',
	whatsapp = 'whatsapp',
}

export const campaignTemplateName = {
	sms: 'sharedVideoSms',
	emailSubject: 'sharedVideoEmail',
	resendEmail: 'resendStoryEmail',
	whatsapp: 'sharedVideoWhatsapp',
};

export enum CampaignPersonalizationEnum {
	oneToOne = 'oneToOne',
	oneToAll = 'oneToAll',
	oneToWorld = 'oneToWorld',
	collectVideos = 'collectVideos',
	openSubmissions = 'openSubmissions',
	reels = 'reels',
	embed_reels = 'embeddableReels',
	SMS = 'sms',
	milestones = 'milestones',
	collectVideosSkipTemplates = 'collectVideosSkipTemplates', //TODO: REMOVE DEPRECATED: For campaigns that skip the templates step
}

export enum CampaignCreationMethodEnum {
	createToDos = 'createToDos',
	videoFromLibrary = 'videoFromLibrary',
	openSubmissions = 'openSubmissions',
	collectVideos = 'collectVideos',
	noVideo = 'noVideo',
	mixed = 'mixed',
}

export enum CampaignTypeDisplayName {
	oneToOne = 'One to one',
	oneToAll = 'One to many',
	oneToWorld = 'Website',
	collectVideos = 'Collect videos',
	collectVideosOpenSubmissions = 'Collect videos • Open submissions',
	reels = 'Reel',
	embed_reels = 'Embeddable Reel',
	SMS = 'Texting campaign',
	nicheInbox = 'Niche Inbox',
	whatsapp = 'WhatsApp campaign',
	SmsMessage = 'Text message',
	whatsappMessage = 'WhatsApp message',
	VideoMessage = 'Video Message',
}

export enum AudienceHandlingTypeEnum {
	ONE_TIME_SYNC = 'oneTimeSync',
	ADDITIVE = 'additive',
	MAPPED = 'mapped',
}

export enum DeliveryChannelEnum {
	SMS = 'sms',
	EMAIL = 'email',
	/**
	 * @deprecated Use the `deliveryChannels` array on `CampaignType` instead.
	 * `ALL` maps to `['sms', 'email']`. This value is retained only for
	 * backward-compatibility with campaigns persisted before the
	 * `deliveryChannel` -> `deliveryChannels` migration.
	 */
	ALL = 'all',
	NICHE_INBOX = 'niche_inbox',
}

/**
 * Individual delivery channel values that can appear inside
 * `CampaignType.deliveryChannels`. Unlike `DeliveryChannelEnum`, this union
 * does NOT include the deprecated aggregate `'all'` value.
 */
export type DeliveryChannel = 'sms' | 'email' | 'niche_inbox';

export enum CampaignActionRequired {
	WAITING_VIDEO_SUBMISSIONS = 'waitingVideoSubmissions',
	APPROVE_VIDEOS = 'approveVideos',
	APPROVE_NEW_CONTACTS = 'approveNewContacts',
	SET_AS_RUNNING = 'setAsRunning',
	NONE = 'none',
	COMPLETE = 'completed',
}

export enum WebRecorderURLs {
	DEV = 'https://web-recorder.goodkind-dev.com',
	QA = 'https://web-recorder.goodkind-qa.com',
	PROD = 'https://web-recorder.goodkind.app',
	LOCAL = 'http://localhost:8082',
}

export const RepeatedCampaignNameErrorText =
	'This name is already in use. Please enter an unique name.';

export enum AdvanceAICampaignsEnabledFeaturesEnum {
	APPLY = 'advance-enable-ai-generated-campaign-apply',
	ADMIT = 'advance-enable-ai-generated-campaign-admit',
	COMMIT = 'advance-enable-ai-generated-campaign-commit',
	ENROLL = 'advance-enable-ai-generated-campaign-enroll',
}

export enum AdvanceAICampaignsSendFeaturesEnum {
	APPLY = 'advance-send-ai-generated-campaign-apply',
	ADMIT = 'advance-send-ai-generated-campaign-admit',
	COMMIT = 'advance-send-ai-generated-campaign-commit',
	ENROLL = 'advance-send-ai-generated-campaign-enroll',
}

export enum DACampaignFeatureIdEnum {
	ACCEPT = 'advance-enable-ai-generated-campaign-accept-da',
	CONFIRM = 'advance-enable-ai-generated-campaign-confirm-da',
	ONBOARDED = 'advance-enable-ai-generated-campaign-onboarded-da',
	ENROLL = 'advance-enable-ai-generated-campaign-enroll-da',
	COMMIT = 'advance-enable-ai-generated-campaign-commit-da',
}

export const DOWN_FUNNEL_ENROLLMENT_STEP_FEATURE_IDS: string[] = [
	AdvanceAICampaignsEnabledFeaturesEnum.ADMIT,
	AdvanceAICampaignsEnabledFeaturesEnum.ENROLL,
	AdvanceAICampaignsEnabledFeaturesEnum.COMMIT,
];

export const DOWN_FUNNEL_DA_ENROLLMENT_STEP_FEATURE_IDS: string[] = [
	DACampaignFeatureIdEnum.ENROLL,
	DACampaignFeatureIdEnum.COMMIT,
];

export const AdvanceCampaignsRequirementIdsEnum = {
	ADVANCE_CRM_DATA_ON_TRACK: 'advance-crm-data-on-track',
	ADVANCE_CRM_DATA_ON_TRACK_DA_SUPPLEMENTAL:
		'advance-crm-data-on-track-da-supplemental',
};
